/* eslint-disable default-case-last */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable padding-line-between-statements */
import uwMessages from './UnderwritingComponent.messages';

function getTranslateJobType(type) {
    switch (type) {
        case 'PolicyChange':
            return 'gateway.views.job-uwissues.endorsement';
        case 'Cancellation':
            return 'gateway.views.job-uwissues.cancellation';
        case 'Renewal':
            return 'gateway.views.job-uwissues.renewal';

        default:
        case 'Submission':
            return 'gateway.views.job-uwissues.quote';
    }
}

function getTranslateWithdrawn(type, isAgent) {
    if (type === 'Renewal' && !isAgent) {
        return {
            link: uwMessages.cancelQuote,
            message: uwMessages.reasonCancellation,
        };
    }

    return {
        link: type === 'PolicyChange' ? uwMessages.withDrawPolicyChangeJOB : uwMessages.withDrawJOB, // DE17844
        message: uwMessages.reasonContinue,
    };
}

function getReferredToUnderwriterMessage(type) {
    // 2021-06-22 - Debra Frum - US19708 - Underwriting Issues - Residential - Renewals
    // Process and message for Renewals will be the same as other transactions
    // if (type === 'Renewal') {
    //     return 'gateway.views.job-uwissues.You can still withdraw the renewal. If you decide not to, the underwriter will continue with the review process';
    // }
    return uwMessages.reviewCompleteInfo;
}

export default function (job, isAgent) {
    const uwIssues = job ? job.underwritingIssues || [] : [];

    return {
        get uwIssues() {
            return uwIssues;
        },

        get hasUwIssues() {
            return uwIssues.length > 0;
        },

        // 2021-06-24 - Debra Frum - US19708 - Underwriting Issues - Residential - Renewals
        get hasBlockingUwIssues() {
            return this.blockingUWIssues.length > 0;
        },

        // US12420 - Underwriting Issues - Residential - Submissions
        get hasUwIssuesExcludingNonBlocking() {
            return uwIssues.some(issue => issue.onOfferings && issue.onOfferings.some(offering => offering.currentBlockingPoint && !['NonBlocking'].includes(offering.currentBlockingPoint))) ||
                uwIssues.some(issue => !issue.onOfferings && !['NonBlocking'].includes(issue.currentBlockingPoint));
        },

        get hasOnlyNonBlockingUWIssues() {
            return uwIssues.every(issue => issue.onOfferings && 
                issue.onOfferings.every(offering => offering.currentBlockingPoint 
                && ['NonBlocking'].includes(offering.currentBlockingPoint)
                && !offering.hasApprovalOrRejection))           
        },

        get hasBlockingUWIssues() {
            return uwIssues.every(issue => issue.onOfferings && 
                issue.onOfferings.some(offering => offering.hasApprovalOrRejection))           
        },

        get hasNonBlockingUWIssuesButApproved() {
            return uwIssues.every(issue => issue.onOfferings && 
                issue.onOfferings.every(offering => offering.currentBlockingPoint 
                && ['NonBlocking'].includes(offering.currentBlockingPoint))) && 
                uwIssues.some(issue => issue.onOfferings && issue.onOfferings.some(offering => offering.hasApprovalOrRejection))
                     
        },

        get offerings() {
            return uwIssues[0] && uwIssues[0].offerings;
        },

        get uwIssuesAreBlocking() {
            return uwIssues.some(issue => issue.onOfferings && issue.onOfferings.some(offering => offering.currentBlockingPoint && !['NonBlocking', 'Approved'].includes(offering.currentBlockingPoint))) ||
                uwIssues.some(issue => !issue.onOfferings && !['NonBlocking', 'Approved'].includes(issue.currentBlockingPoint));
        },

        // US12420 - Underwriting Issues - Residential - Submissions
        get blockingUWIssues() {

            const approvedOrRejected = uwIssues.filter(issue => issue.hasApprovalOrRejection);
            const notApprovedOrRejected = uwIssues.filter(issue => !issue.hasApprovalOrRejection).filter(issue => issue.onOfferings && issue.onOfferings.some(offering => offering.currentBlockingPoint && !['NonBlocking'].includes(offering.currentBlockingPoint)))
                .concat(uwIssues.filter(issue => !issue.onOfferings && !['NonBlocking'].includes(issue.currentBlockingPoint)));

            return approvedOrRejected.concat(notApprovedOrRejected);
        },

        // US12420 - Underwriting Issues - Residential - Submissions
        get hasBlockingUWIssuesAnytime() {

            return this.blockingUWIssues.length > 0;
        },

        // US12420 - Underwriting Issues - Residential - Submissions
        get hadBlockingUWIssuesAndAllApproved() {

            // Had UWissues before but all are approved now
            return this.blockingUWIssues.length > 0 && !this.uwIssuesAreBlocking;
        },

        // 2021-06-24 - Debra Frum - US19708 - Underwriting Issues - Residential - Renewals
        // Returns true if there any blocking UW Issues that are Rejected
        get hasBlockingUWIssuesAndAnyRejected_TWIA() {
            return uwIssues.some(issue => issue.onOfferings 
                && issue.onOfferings.some(offering => offering.currentBlockingPoint
                     && ['Rejected'].includes(offering.currentBlockingPoint)))
                || uwIssues.some(issue => !issue.onOfferings 
                    && ['Rejected'].includes(issue.currentBlockingPoint));
        },

        // 2021-06-22 - Debra Frum - US19708 - Underwriting Issues - Residential - Renewals
        // Returns true if there any blocking UW Issues that are open (not Approved and not Rejected)
        // DE18104,DE18106,DE18154,DE18155,DE18156,DE18157
        get hasBlockingUWIssuesAndAnyOpen_TWIA() {
            return uwIssues.some(issue => issue.onOfferings 
                && issue.onOfferings.some(offering => offering.currentBlockingPoint 
                    && !['NonBlocking', 'Rejected'].includes(offering.currentBlockingPoint) 
                    && !offering.hasApprovalOrRejection))
                || uwIssues.some(issue => !issue.onOfferings 
                    && !['NonBlocking', 'Rejected'].includes(issue.currentBlockingPoint 
                        && !issue.hasApprovalOrRejection));
        },

        get translateJobType() {
            if (job) {
                return getTranslateJobType(job.type);
            }
            return undefined;
        },

        get jobType() {
            if (job) {
                return job.type;
            }
            return undefined;
        },

        get uwIssuesHaveBeenInspectedByUW() {
            return uwIssues.some(issue => issue.onOfferings && issue.onOfferings.some(offering => offering.hasApprovalOrRejection));
        },

        get translateWithdrawn() {
            if (job) {
                return getTranslateWithdrawn(job.type, isAgent);
            }
            return undefined;
        },

        get getReferredToUnderwriterMessage() {
            if (job) {
                return getReferredToUnderwriterMessage(job.type);
            }
            return undefined;
        },

        /*
        // OOTB code with a bug - job.uWLocked is always undefined because there is syntax error
        get isLockedToUser() {
            if (job) {
                return job.uWLocked && job.isEditLocked;
            }
            return undefined;
        } */

        get isLockedToUser() {
            // US12420 - Underwriting Issues - Residential - Submissions
            if (job) {
                return job.uwlocked && job.isEditLocked;// Fixed syntax error for UWLocked, fortunately this is false mose of the time so it worked.
            }
            return undefined;
        }
    };
}
